/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ColumnTexts } from '../../enums';
import { FileSizeUnitNames, FileSizeUnitsInBytes, isNumber } from '../../core';

export interface DataSizeFormat {
    value: number | null;
    text: string;
}

const dataSizeToString = (
    value: number | null,
    pointFixed = 0,
    startUnit: string | number = 0,
    unitName: string = FileSizeUnitNames.B,
    formats: DataSizeFormat[] = []
): string => {
    const defFormats: DataSizeFormat[] = [
        {
            value: undefined,
            text: ColumnTexts.DashSymbol,
        },
        {
            value: null,
            text: ColumnTexts.DashSymbol,
        },
        {
            value: -1,
            text: ColumnTexts.DashSymbol,
        },
    ];

    defFormats.forEach((defFormatItem: DataSizeFormat) => {
        const item = formats.find((formatItem: DataSizeFormat) => defFormatItem.value === formatItem.value);

        if (!item) {
            formats.push(defFormatItem);
        }
    });

    const formatItem = formats.find((formatItem: DataSizeFormat) => formatItem.value === value);

    if (formatItem) {
        return formatItem.text;
    } else if (value === 0) {
        return `${value}`;
    }

    // K - 2^10, M - 2^20, G - 2^30, T - 2^40, P - 2^50, E - 2^60, Z - 2^70, Y - 2^80
    const unitPrefixes: string[] = ['', 'K', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y'];
    const unitSize: number = FileSizeUnitsInBytes.KB;
    let unitIndex: number = isNumber(startUnit) ? startUnit as number : unitPrefixes.indexOf((startUnit as string).toUpperCase());

    for (let i = unitIndex; i < unitPrefixes.length; i += 1) {
        const valueRoundingCondition = pointFixed ? value < unitSize : value % unitSize !== 0;
        if (valueRoundingCondition) {
            break;
        }

        value /= unitSize;
        unitIndex += 1;
    }

    return `${value.toFixed(pointFixed)} ${unitPrefixes[unitIndex]}${unitName}`;
};

export {
    dataSizeToString,
};
